/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampTripShowResponse } from '../../models/camp-trip-show-response';

export interface GetCampTripShow$Params {
  id: string;
}

export function getCampTripShow(http: HttpClient, rootUrl: string, params: GetCampTripShow$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripShowResponse>> {
  const rb = new RequestBuilder(rootUrl, getCampTripShow.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripShowResponse>;
    })
  );
}

getCampTripShow.PATH = '/v1/camp-trip/{id}';
